<div style="margin-left:10px;margin-right:10px" class="component">
  <h3>
    {{pageName()}}
  </h3>
  <mat-accordion>
    <mat-expansion-panel (opened)="searchParametersSectionOpen = true"
                         (closed)="searchParametersSectionOpen = false"
                         [expanded]="searchParametersSectionOpen"
                         id="expansionPanel"
                         class="expansion-visable">
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{parametersName()}}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-component-unspsc-search-parameters *ngIf="isUnspscSearch"
                                          (searchClicked)="unspscSearch($event)"
                                          (clearParametersClicked)="clearParameters()">

      </app-component-unspsc-search-parameters>
      <app-search-parameters *ngIf="!isUnspscSearch"
                             (searchParameters)="searchParameters = $event"
                             [searchInProgress]="searching"
                             (cancelSearchClicked)="cancelSearch()"
                             (searchClicked)="search()"
                             (clearParametersClicked)="clearParameters()"
                             [incomingBatchId]="searchBatchId">
      </app-search-parameters>
    </mat-expansion-panel>
  </mat-accordion>
  <br />
  <!-- End of serach parameters -->
  <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" animationDuration="0ms" [(selectedIndex)]="selectedTabIndex">
    <mat-tab id="resultsTab">
      <ng-template mat-tab-label>
        <span class="labelBold">Results</span>
      </ng-template>
      <app-xref-display-component [xrefData]="searchResultsData"
                              [searching]="searching"
                              [hasSearched]="hasSearched"
                              [loadError]="loadError"
                              [internalUser]="internalUser"
                              [xrefColumnDisplayOrder]="columnOrderSetUp"
                              [canEdit]="canEdit"
                              [allowColumnChanges]="true"
                              (exportClicked)="ExportData($event)"
                              (saveChangesClicked)="SaveChanges()"
                              [singleExport]="!isMultiExport()"
                              [multiExport]="isMultiExport()"
                              [isUpdating]="updatingXrefs"
                              [doubleHeader]="true"
                              [exportButtonData]="exportSelection()"
                              [allowUpload]="isUnspscSearch"
                              (uploadClicked)="uploadDifferingUnspscUpdate()">
      </app-xref-display-component>
    </mat-tab>
    <mat-tab *ngIf="!isUnspscSearch" id="exportsTab">
      <ng-template mat-tab-label>
        <span class="labelBold">My Exports</span>
      </ng-template>
      <app-file-download #fileDownload [exportType]="'Search'"></app-file-download>
    </mat-tab>
  </mat-tab-group>
</div>
